import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { connect } from 'react-redux';

import { siteboardAction, } from '../actions/defaultActions';
import { DateStringMMDDYYYY, Schedule, SET_ALERT, SET_EDIT_SCHEDULE_DIALOGUE_SHOWING, EDIT_SCHEDULE, } from '../actions/types';
import { format } from 'date-fns';

import PopupWindow from './PopupWindow';
import PushButton from './PushButton';
import CalendarPicker from './CalendarPicker';

const EditScheduleDialogue = ({ _projects, _schedules, _editScheduleDialogueOpen, _editScheduleDialogueScheduleId, siteboardAction, }) => {

  const selectedSchedule = _schedules[_editScheduleDialogueScheduleId];
  const selectedProject = selectedSchedule ? _projects[selectedSchedule.projectId] : undefined;

  const [cursorDate, setCursorDate] = useState(format(selectedSchedule ? DateStringMMDDYYYY.toDateObject(selectedSchedule.beginDate).getTime() : new Date().getTime(), 'MM/dd/yyyy'));

  const inputDateRef = useRef(null);

  const closeDialogue = useCallback(() => {
    siteboardAction(SET_EDIT_SCHEDULE_DIALOGUE_SHOWING, { isOpen: false });
  }, [siteboardAction]);

  const submitDialogue = useCallback(() => {
    try {
      const onSuccess = (output) => { closeDialogue(); };
      siteboardAction(EDIT_SCHEDULE, {
        subscriptionId: selectedProject.subscriptionId,
        schedule: {
          ...selectedSchedule,
          beginDate: DateStringMMDDYYYY.validate(cursorDate),
        },
      }, onSuccess);
    } catch(error) {
      siteboardAction(SET_ALERT, { message: error.message }); 
    }
  }, [closeDialogue, cursorDate, selectedProject.subscriptionId, selectedSchedule, siteboardAction]);

  if(typeof selectedSchedule === 'undefined') return (<></>);
  if(typeof selectedProject === 'undefined') return (<></>);

  return (
    <PopupWindow title={`Schedule Start Date`} closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='max-w-screen-sm bg-[#333] text-white'>
        {/* filler to make the window expand to its max width */}
        <div className='h-0 w-[90vw] max-w-full'></div>
        <div className='flex flex-col gap-y-8'>
          {/* begin date
          <div className='w-full'>
            <label className='flex text-sm font-medium mb-1 gap-x-2'><p>Start Date</p><p className='opacity-50'>(mm/dd/year)</p></label>
            <input 
              ref={inputDateRef}
              className='w-full text-white rounded-md px-3 py-1.5 bg-[#444247] hover:bg-[#656565] focus:bg-[#656565]' 
              type='text' 
              value={dateInput}
              onChange={(event) => { setDateInput(event.target.value); }}
              onKeyUp={(event) => { if(event.key === 'Enter') { submitDialogue(); } }}
            />
          </div> */}
          <div className='h-[400px]'>
            <CalendarPicker selectedDate={cursorDate} onDateChange={(dateString) => { setCursorDate(dateString); }} onSubmit={submitDialogue} />
          </div>
          <div className='text-center font-medium'><span className='opacity-70'>Selected:</span> {format(cursorDate, 'iiii, MMMM dd, yyyy')}</div>
          <div className='flex gap-4'>
            <button  
              className={`border border-[#888] hover:border-[#000] hover:bg-[#000] text-white w-full py-[7px] font-bold select-none rounded-lg`}
              onClick={() => { closeDialogue(); }}
            >
              Cancel
            </button>
            <PushButton 
              textColor='white'
              bgColor='#471cff'
              hoverBgColor='#603aff'
              onClick={() => { submitDialogue(); }}
            >
              <div className='flex items-center'>Apply</div>
            </PushButton>
          </div>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _projects: state.serverSynced.projects,
  _schedules: state.serverSynced.schedules,
  _editScheduleDialogueOpen: state.localEphemeral.editScheduleDialogueOpen,
  _editScheduleDialogueScheduleId: state.localEphemeral.editScheduleDialogueScheduleId,
}};
export default connect(mapStateToProps, {siteboardAction, })(EditScheduleDialogue);
